import { EmptyState, Button, Icon, icons, Stack } from '@agentisai/design-system';
import { useNavigate } from 'react-router';

/** NotFoundPage — public catch-all (*). DS EmptyState + a router-driven
 *  "back to home" action. No guards. */
export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Stack as="main" align="center" justify="center" style={{ minHeight: '70vh', padding: 48 }}>
      <EmptyState
        icon={<Icon as={icons.Search} size="lg" />}
        title="Page not found"
        description="We couldn't find that page. It may have moved, or the link may be broken."
        action={
          <Button variant="primary" onClick={() => navigate('/')}>
            Back to home
          </Button>
        }
      />
    </Stack>
  );
}
NotFoundPage.displayName = 'NotFoundPage';
